import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { sendEvent } from 'helper/analytics';
import { AnalyticsEventData } from 'models/analytics';

import './LinkWithAnalytics.scss';

type LinkWithAnalyticsProps = LinkProps & AnalyticsEventData;

export class LinkWithAnalytics extends React.Component<LinkWithAnalyticsProps, {}> {
  constructor(props: LinkWithAnalyticsProps) {
    super(props);

    this.onClickWithSendAnalyticsEvent = this.onClickWithSendAnalyticsEvent.bind(this);
  }

  render() {
    const { onClick, category, action, label, value, children, ...rest } = this.props;
    const eventData = { category, action, label, value };
    return (
      <Link
        onClick={this.onClickWithSendAnalyticsEvent(onClick, eventData)}
        {...rest}
      >
        {children}
      </Link>
    );
  }

  private onClickWithSendAnalyticsEvent(
    onClick: React.EventHandler<React.MouseEvent<HTMLAnchorElement>> | undefined,
    eventData: AnalyticsEventData
  ) {
    return (event: React.MouseEvent<HTMLAnchorElement>) => {
      sendEvent(eventData);
      if (onClick) {
        onClick(event);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LinkWithAnalytics/LinkWithAnalytics.tsx